import React, { forwardRef } from "react";
import { connect } from "react-redux";
import { DragLayer } from "react-dnd";
import ItemTypes from "../../../constants/ItemTypes";
import BoxDragPreview from "./Layer/PrintArea/BoxDragPreview";
import TextElement from "./Layer/PrintArea/TextElement";
import ImageElement from "./Layer/PrintArea/ImageElement";
import { calculateBoundingBoxForSelectedElements } from "../../common/layer";

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    delta: monitor.getDifferenceFromInitialOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

const layerStyles = {
  position: "absolute",
  pointerEvents: "none",
  zIndex: 1000,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%"
};

function getItemStyles(props) {
  const { initialOffset, currentOffset, item, delta } = props;
  if (!initialOffset || !currentOffset) {
    //console.log('hiding');
    return {
      display: "none"
    };
  }

  const layer = props.design.layer_set[item.layerId];
  const layerWidth = layer.width * 72 * props.design.preview_scale;
  const layerHeight = layer.height * 72 * props.design.preview_scale;
  const boundingbox = calculateBoundingBoxForSelectedElements(
    props.design,
    props.design.layer_set[item.layerId]
  );
  //console.log("minX:" + boundingbox.minX + " minY:" + boundingbox.minY + " maxX:" + boundingbox.maxX + " maxY:" + boundingbox.maxY + " width:" + boundingbox.width + '  height:' + boundingbox.height + " x:" + item.left + ' y:' + item.top + ' dx:' + delta.x + ' dy:' + delta.y)
  let x = null,
    y = null;
  if (item.isSelected) {
    x = boundingbox.minX + delta.x;
    y = boundingbox.minY + delta.y;
    x = x < 0 ? 0 : x;
    y = y < 0 ? 0 : y;
    if (x + boundingbox.width > layerWidth) {
      x = layerWidth - boundingbox.width;
    }
    if (y + boundingbox.height > layerHeight) {
      y = layerHeight - boundingbox.height;
    }
  } else {
    x = item.left + delta.x;
    y = item.top + delta.y;
    x = x < 0 ? 0 : x;
    y = y < 0 ? 0 : y;
    if (x + item.width >= layerWidth) {
      x = layerWidth - item.width;
    }
    if (y + item.height >= layerHeight) {
      y = layerHeight - item.height;
    }
  }

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform
  };
}

const CustomDragLayer = forwardRef((props, ref) => {
  const renderItem = (type, item) => {
    if (item.isSelected) {
      return (
        <BoxDragPreview
          layer={props.design.layer_set[item.layerId]}
          design={props.design}
        />
      );
    } else {
      switch (type) {
        case ItemTypes.TEXT:
          return (
            <TextElement
              noOffset={true}
              index={item.index}
              layerId={item.layerId}
              textElement={item.element}
              itemType={type}
              design={props.design}
              disableInteractivity={false}
            />
          );
        case ItemTypes.IMAGE:
          return (
            <ImageElement
              noOffset={true}
              index={item.index}
              layerId={item.layerId}
              imageElement={item.element}
              itemType={type}
              design={props.design}
              disableInteractivity={false}
            />
          );
        default:
          return null;
      }
    }
  };

  const { itemType, item, isDragging } = props;

  if (!isDragging || item.layerId !== props.layerId) {
    return null;
  }

  return (
    <div style={layerStyles} ref={ref}>
      <div className="drag__layer" style={getItemStyles(props)}>
        {renderItem(itemType, item)}
      </div>
    </div>
  );
});

CustomDragLayer.displayName = "CustomDragLayer";

function mapStateToProps(state) {
  return {
    design: state.design.present
  };
}

export default DragLayer(collect)(
  connect(mapStateToProps, null, null, { forwardRef: true })(CustomDragLayer)
);
